import {get, writable} from "svelte/store";
import {eliminar, restaurar, todos} from '../Api/trabajadores';

const estadoInicial = {
  cargando: false,
  error: null,
  listado: [],
  listadoIndexado: {},
  trabajadorEliminando: null,
  errorEliminacion: null,
  trabajadorRestaurando: null,
  errorRestauracion: null
};

const store = writable(estadoInicial);

export default {
  subscribe: store.subscribe,
  cargar: (activos = true) => {
    const timeout = setTimeout(() => store.update(valor => ({...valor, cargando: true})), 100);

    store.update(() => ({
      ...estadoInicial,
      cargando: true
    }));

    todos(activos)
        .then(listado => store.update(valor => ({
          ...valor,
          listado: listado,
          listadoIndexado: listado.reduce((acc, x) => ({[x.id]: x, ...acc}), {}),
          error: false
        })))
        .catch(e => store.update(valor => ({...valor, error: e})))
        .finally(() => {
          clearTimeout(timeout);
          store.update(valor => ({...valor, cargando: false}));
        });
  },
  eliminarTrabajador: trabajador => {
    store.update(estado => ({
      ...estado,
      trabajadorEliminando: trabajador,
      errorEliminacion: null
    }));
  },
  eliminaTrabajadorDeVerdad: () => {
    const trabajador = get(store).trabajadorEliminando;
    eliminar(trabajador.id)
        .then(() => {
          store.update(estado => {
            const nuevoListado = estado.listado.filter(x => x !== estado.trabajadorEliminando);
            return {
              ...estado,
              trabajadorEliminando: null,
              errorEliminacion: null,
              listado: nuevoListado,
              listadoIndexado: nuevoListado.reduce((acc, x) => ({[x.id]: x, ...acc}), {}),
            };
          });
        })
        .catch(e => store.update(valor => ({...valor, errorEliminacion: e.response.data})));
  },
  restaurarTrabajador: trabajador => {
    store.update(estado => ({
      ...estado,
      trabajadorRestaurando: trabajador,
      errorRestauracion: null
    }));
  },
  restauraTrabajadorDeVerdad: () => {
    const trabajador = get(store).trabajadorRestaurando;
    restaurar(trabajador.id)
        .then(() => {
          store.update(estado => {
            const nuevoListado = estado.listado.filter(x => x !== estado.trabajadorRestaurando);
            return {
              ...estado,
              trabajadorRestaurando: null,
              errorRestauracion: null,
              listado: nuevoListado,
              listadoIndexado: nuevoListado.reduce((acc, x) => ({[x.id]: x, ...acc}), {}),
            };
          });
        })
        .catch(e => store.update(valor => ({...valor, errorRestauracion: e.response.data})));
  }
};